module.exports = __webpack_public_path__ + "media/images/blue-b7bdf6d22dd20deb578b7cadd67a3f4e.svg";